export default __webpack_public_path__ + "static/AppBeers10-d8eb789b1bf8a96cecb3dbd493b1de95.png";